import { render, staticRenderFns } from "./insect.vue?vue&type=template&id=4d6676db&scoped=true&"
import script from "./insect.vue?vue&type=script&lang=js&"
export * from "./insect.vue?vue&type=script&lang=js&"
import style0 from "./insect.vue?vue&type=style&index=0&id=4d6676db&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6676db",
  null
  
)

export default component.exports